(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-product-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  function updateUI(track) {
    var wrapper = track.closest('.bpg-products');
    if (!wrapper) return;

    /* ── Arrow disabled state ── */
    var prevBtn = wrapper.querySelector('.bpg-slider__btn--prev');
    var nextBtn = wrapper.querySelector('.bpg-slider__btn--next');
    var atStart = track.scrollLeft <= 2;
    var atEnd   = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    if (prevBtn) prevBtn.disabled = atStart;
    if (nextBtn) nextBtn.disabled = atEnd;

    /* ── Progress bar ── */
    var fillId  = wrapper.getAttribute('data-slider-id');
    var fill    = document.getElementById('bpg-fill-' + fillId);
    if (fill) {
      var scrollable = track.scrollWidth - track.clientWidth;
      var pct = scrollable > 0 ? (track.scrollLeft / scrollable) * 100 : 0;
      fill.style.width = pct + '%';
    }
  }

  function initSlider(btn) {
    var trackId = btn.getAttribute('data-track');
    var track   = document.getElementById(trackId);
    if (!track) return;
    var isPrev = btn.classList.contains('bpg-slider__btn--prev');
    btn.addEventListener('click', function () {
      var card = track.querySelector('.bpg-product-card');
      var scrollAmount = card ? card.offsetWidth + 16 : 200;
      track.scrollBy({ left: isPrev ? -scrollAmount : scrollAmount, behavior: 'smooth' });
    });
  }

  function init() {
    document.querySelectorAll('.bpg-slider__btn').forEach(initSlider);
    document.querySelectorAll('.bpg-slider__track').forEach(function (track) {
      updateUI(track);
      track.addEventListener('scroll', function () { updateUI(track); }, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
